/** Company logos (spec § V2 user interface): PNG or JPEG, at most 2 MiB — the same limits rest_server enforces. */
export const MAX_LOGO_BYTES = 2 * 1024 * 1024;
export const LOGO_TYPES: readonly string[] = ['image/png', 'image/jpeg'];

export type LogoProblem = 'type' | 'size';

export function logoProblem(file: { type: string; size: number }): LogoProblem | null {
  if (!LOGO_TYPES.includes(file.type)) return 'type';
  if (file.size > MAX_LOGO_BYTES) return 'size';
  return null;
}
